import { useState, useEffect } from "react";
import "./ConfigModal.css";

export const ConfigModal = ({ isOpen, onClose, config, onSave }) => {
  const [tempConfig, setTempConfig] = useState(config);

  useEffect(() => {
    setTempConfig(config);
  }, [config]);

  const handleSave = () => {
    onSave(tempConfig);
    onClose();
  };

  const handleReset = () => {
    const defaultConfig = {
      event_top_min: 3,
      event_top_max: 20,
      event_score_min: 0,
      event_score_max: 3,
      event_highlights: false,
      msg_top_min: 5,
      msg_top_max: 30,
      msg_score_min: 0,
      msg_score_max: 2,
      msg_highlights: false,
    };
    setTempConfig(defaultConfig);
  };

  if (!isOpen) return null;

  return (
    <div className="config-overlay" onClick={onClose}>
      <div className="config-modal" onClick={(e) => e.stopPropagation()}>
        <div className="config-header">
          <h3>⚙️ Configurazione Parametri Chat</h3>
          <button className="config-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="config-content">
          {/* Eventi Section */}
          <div className="config-section">
            <h4>🎯 Parametri Eventi</h4>

            <div className="config-row">
              <label>Risultati Eventi (Min-Max)</label>
              <div className="range-group">
                <input
                  type="range"
                  min="1"
                  max="50"
                  value={tempConfig.event_top_min}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      event_top_min: parseInt(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.event_top_min}</span>
                <span>-</span>
                <input
                  type="range"
                  min="1"
                  max="50"
                  value={tempConfig.event_top_max}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      event_top_max: parseInt(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.event_top_max}</span>
              </div>
            </div>

            <div className="config-row">
              <label>Punteggio Eventi (Min-Max)</label>
              <div className="range-group">
                <input
                  type="range"
                  min="0"
                  max="5"
                  step="0.1"
                  value={tempConfig.event_score_min}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      event_score_min: parseFloat(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.event_score_min}</span>
                <span>-</span>
                <input
                  type="range"
                  min="0"
                  max="5"
                  step="0.1"
                  value={tempConfig.event_score_max}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      event_score_max: parseFloat(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.event_score_max}</span>
              </div>
            </div>

            <div className="config-row">
              <label>Evidenziazione Eventi</label>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  id="eventHighlights"
                  checked={tempConfig.event_highlights}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      event_highlights: e.target.checked,
                    }))
                  }
                />
                <label
                  htmlFor="eventHighlights"
                  className="toggle-label"
                ></label>
              </div>
            </div>
          </div>

          {/* Messaggi Section */}
          <div className="config-section">
            <h4>💬 Parametri Messaggi</h4>

            <div className="config-row">
              <label>Risultati Messaggi (Min-Max)</label>
              <div className="range-group">
                <input
                  type="range"
                  min="1"
                  max="100"
                  value={tempConfig.msg_top_min}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      msg_top_min: parseInt(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.msg_top_min}</span>
                <span>-</span>
                <input
                  type="range"
                  min="1"
                  max="100"
                  value={tempConfig.msg_top_max}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      msg_top_max: parseInt(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.msg_top_max}</span>
              </div>
            </div>

            <div className="config-row">
              <label>Punteggio Messaggi (Min-Max)</label>
              <div className="range-group">
                <input
                  type="range"
                  min="0"
                  max="5"
                  step="0.1"
                  value={tempConfig.msg_score_min}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      msg_score_min: parseFloat(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.msg_score_min}</span>
                <span>-</span>
                <input
                  type="range"
                  min="0"
                  max="5"
                  step="0.1"
                  value={tempConfig.msg_score_max}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      msg_score_max: parseFloat(e.target.value),
                    }))
                  }
                />
                <span>{tempConfig.msg_score_max}</span>
              </div>
            </div>

            <div className="config-row">
              <label>Evidenziazione Messaggi</label>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  id="msgHighlights"
                  checked={tempConfig.msg_highlights}
                  onChange={(e) =>
                    setTempConfig((prev) => ({
                      ...prev,
                      msg_highlights: e.target.checked,
                    }))
                  }
                />
                <label htmlFor="msgHighlights" className="toggle-label"></label>
              </div>
            </div>
          </div>
        </div>

        <div className="config-actions">
          <button className="config-btn reset" onClick={handleReset}>
            🔄 Reset Default
          </button>
          <div>
            <button className="config-btn cancel" onClick={onClose}>
              Annulla
            </button>
            <button className="config-btn save" onClick={handleSave}>
              💾 Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
